// src/Header.js
import React, { useState } from 'react';
import './Header.css';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from "@mui/material/Toolbar";
import Link from '@mui/material/Link';
import InlineLogo from '../images/logo.webp';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Grid from '@mui/material/Grid';

const linksHeader = [
    {
        to: 'https://inlinetracking.com/pallet-process/',
        name: 'Pallet Process'
    },
    {
        to: 'https://inlinetracking.com/our-story/',
        name: 'Our Story'
    },
    {
        to: 'https://inlinetracking.com/contact-us/',
        name: 'Contact'
    },
    {
        to: 'https://mfiles.inlinepallets.com.au/inlinepallets/default.asp',
        name: 'Login'
    },

];

export default function Navbar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const [isShown, setIsShown] = useState(false);
    const [hidden, setHidden] = useState(false);

    const handleClick = () => {
        setIsShown(current => !current);
        setHidden(current => !current);
    };

    return (
        <AppBar sx={{ backgroundColor: 'rgba(0,0,0,0.54)' }} position='sticky'>
            <Grid container className='header1'>
                <Grid item xs={'auto'}>
                    <PhoneIcon fontSize='small' sx={{ pt: '3px' }} />
                </Grid>

                <Grid item xs={'auto'}>
                    <Typography className="header1-subtitle1">(08) 7 123 4201
                    </Typography>
                </Grid>

                <Button
                    variant='headerbutton'
                    rel="noopener noreferrer"
                    href={`mailto:helpme@inlinetracking.com.au`}
                >
                    <EmailIcon fontSize='small' />
                    <Typography className='header1-subtitle1 emailText'>
                        helpme@inlinetracking.com.au
                    </Typography>
                </Button>
            </Grid>

            <Toolbar disableGutters className='top'>
                <Link href='/'>
                    <img src={InlineLogo} alt='InlineLogo' height='80px' width='238.89px' />
                </Link>

                <Toolbar className='top-toolbar'>
                    {!hidden ?
                        <Box
                            sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}
                        >
                            {linksHeader.map((link) => (
                                <Button
                                    key={link.name}
                                    onClick={handleCloseNavMenu}
                                >
                                    <Typography className='header2-subtitle2' href={link.to} component={Link}>
                                        {link.name}
                                    </Typography>
                                </Button>
                            ))}
                        </Box>
                        : null}

                    <IconButton
                        size="large"
                        color="inherit"
                        aria-label='search'
                        onClick={handleClick}
                    >
                        <SearchIcon />
                    </IconButton>
                    {isShown && (
                        <div>
                            <Input className='searchbar' placeholder="Search..." inputProps='search' />
                            <IconButton
                                size="large"
                                color="inherit"
                                aria-label='search'
                                onClick={handleClick}
                            >
                                <CloseOutlinedIcon />
                            </IconButton>
                        </div>
                    )}

                    {!hidden ?
                        <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="menu"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>

                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                {linksHeader.map((link) => (
                                    <MenuItem key={link.name} onClick={handleCloseNavMenu}>
                                        <Typography className='header3-menuitem' href={link.to} component={Link}>
                                            {link.name}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                        : null}
                </Toolbar>
            </Toolbar>
        </AppBar>
    );
};
